import { RechargeHistoryStatus } from '../types/recharge-history';
export const getRechargeStatus = (rechargeState, rechargeDate, releaseState) => {
    if (rechargeState === 'PENDING') {
        return RechargeHistoryStatus.PAYMENT_PENDING;
    }
    if (rechargeState === 'APPROVED') {
        if (releaseState === 'LIBERATING') {
            return RechargeHistoryStatus.RELEASING_CREDIT;
        }
        if (releaseState === 'LIBERATED') {
            return RechargeHistoryStatus.CREDIT_RELEASED;
        }
    }
    if (rechargeState === 'REJECTED' || rechargeState === 'CANCELED') {
        return RechargeHistoryStatus.CANCELLED;
    }
    return RechargeHistoryStatus.PAYMENT_PENDING;
};
